import { render, staticRenderFns } from "./InitStatus.vue?vue&type=template&id=ed7bc080&scoped=true&"
import script from "./InitStatus.vue?vue&type=script&lang=ts&"
export * from "./InitStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7bc080",
  null
  
)

export default component.exports